jQuery( document ).ready( function ( $ ) {
	function CTA( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-selector v2.0' )
		this.instance = thisInstance
		this.init()
	}

	CTA.prototype.resizeOnWindowChange = function () {
		this.instance.find( '.jtf__ctablock--img-square' ).each( function () {
			if ( $( this ).parents( '.jtf__ctablock--centre' ).length == 0 ) {
				let thisWidth = $( this ).width()
				$( this ).css( { height: thisWidth + 'px' } )
			}
			// Else: Dont resize the image if it's a centred block, will break the image.
		} )
	}

	/**
	 * Default actions happening on device actions
	 */
	CTA.prototype.init = function () {
		const self = this
		// Fire on first load
		self.resizeOnWindowChange()
		// preserve the 16:9 aspect ratio for the block on window resize
		$( window ).resize( function () {
			self.resizeOnWindowChange()
		} )
	}

	setTimeout( function () {
		// Check TWITTER is used on this page before instantiating
		if ( $( '.wp-block-jtf-jtf-cta' ).length > 0 ) {
			// Instatiate a new instance for each block on a page (not that there shoudl be more than 1...)
			$( '.wp-block-jtf-jtf-cta' ).each( function () {
				new CTA( $( this ) )
			} )
		}
	}, 1000 )
} )
